<template>
  <span>
    <!-- MAC: LAN -->
    <div
      v-if="device.mac"
      class="addresses--table-row"
      :title="$t('macAddress') + ': LAN'"
    >
      <span
        class="addresses--table-cell text-xs-right grey--text text--darken-1"
      >LAN</span>
      <span class="addresses--table-cell text-xs-left pl-2">
        {{ device.mac ? device.mac.toUpperCase() : '' }}
      </span>
    </div>
    <!-- MAC: WIFI -->
    <div
      v-if="device.wifimac"
      class="addresses--table-row"
      :title="$t('macAddress') + ': WIFI'"
    >
      <span
        class="addresses--table-cell text-xs-right grey--text text--darken-1"
      >WIFI</span>
      <span class="addresses--table-cell text-xs-left pl-2">
        {{ device.wifimac ? device.wifimac.toUpperCase() : '' }}
      </span>
    </div>
    <!-- IP -->
    <div
      v-if="device.ip"
      class="addresses--table-row"
    >
      <span
        class="addresses--table-cell text-xs-right grey--text text--darken-1"
      >IP</span>
      <span class="addresses--table-cell text-xs-left pl-2">
        {{ device.ip }}
      </span>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.addresses--table-row {
  display: table-row;
  line-height: 1;
}

.addresses--table-cell {
  display: table-cell;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/DeviceAddresses.vue